import { render, staticRenderFns } from "./EditRole.vue?vue&type=template&id=9b4568ae&"
import script from "./EditRole.vue?vue&type=script&lang=ts&"
export * from "./EditRole.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports